import axiosClient from "./axiosClient";

export async function getProductReviews(productId, page = 1, pageSize = 20) {
  const response = await axiosClient.get(`/reviews/products/${productId}`, {
    params: { page, pageSize },
  });
  return response.data;
}

export async function getProductReviewSummary(productId) {
  const response = await axiosClient.get(`/reviews/products/${productId}/summary`);
  return response.data;
}
